var _rect, _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#FFF4F4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.686,
    cy: 156.667,
    r: 21.1667,
    stroke: "#BB3737"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.706,
    cy: 178.334,
    r: 21.1667,
    stroke: "#BB3737"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.667,
    cy: 178.334,
    r: 21.1667,
    stroke: "#BB3737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 163L196 165.5L198 168.5L199.5 172.5L200.5 176.5L194 177.5L190 177L187 176.5L188 172L189.5 168.5L191.5 165.5L193.5 163Z",
    fill: "#BB3737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/Card3.87d87e49ab5e4b72c3c61811cd74be87.svg";
export { ForwardRef as ReactComponent };